import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card card-drawer-right" }
const _hoisted_2 = { class: "card-header drawer-header d-flex flex-row justify-content-between align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "align-items-center justify-content-center font-size-16"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex font-weight-bold justify-content-center align-items-center font-size-16"
}
const _hoisted_5 = {
  key: 0,
  class: "card-body d-flex flex-row height-100 font-size-14 overflow-auto p-0"
}
const _hoisted_6 = {
  key: 0,
  class: "width-100 p-3 d-flex flex-column"
}
const _hoisted_7 = { class: "d-flex flex-row align-items-center min-height-32" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex flex-row align-items-center min-height-32"
}
const _hoisted_9 = {
  key: 1,
  class: "d-flex flex-row align-items-center min-height-32"
}
const _hoisted_10 = {
  key: 1,
  class: "width-100 overflow-auto p-3"
}
const _hoisted_11 = {
  key: 0,
  id: "flow-logs-load-failed"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "height-100" }
const _hoisted_15 = { class: "nav flex-column nav-tabs no-border height-100" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_18 = {
  key: 1,
  class: "card-body d-flex flex-row height-100 font-size-14 overflow-auto p-0"
}
const _hoisted_19 = {
  key: 0,
  class: "width-100 p-3 d-flex flex-column"
}
const _hoisted_20 = {
  key: 0,
  class: "d-flex flex-row align-items-center min-height-32 margin-top-10"
}
const _hoisted_21 = { class: "d-flex flex-row align-items-center min-height-32 margin-top-10" }
const _hoisted_22 = {
  key: 1,
  class: "d-flex flex-row align-items-center min-height-32"
}
const _hoisted_23 = {
  key: 2,
  class: "d-flex flex-row align-items-center min-height-32"
}
const _hoisted_24 = {
  key: 3,
  class: "d-flex flex-row align-items-center min-height-32"
}
const _hoisted_25 = { class: "min-max-width-80" }
const _hoisted_26 = { class: "min-max-width-30 margin-left-3" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "margin-left-3 width-100" }
const _hoisted_29 = { class: "input-div" }
const _hoisted_30 = ["id"]
const _hoisted_31 = { class: "min-max-width-160 margin-left-3" }
const _hoisted_32 = { class: "margin-left-3 width-100" }
const _hoisted_33 = { class: "input-div" }
const _hoisted_34 = ["id"]
const _hoisted_35 = { class: "min-max-width-30 margin-left-3" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 1,
  class: "width-100 overflow-auto p-3"
}
const _hoisted_38 = {
  key: 0,
  class: "d-flex flex-row align-items-center min-height-32 margin-top-10"
}
const _hoisted_39 = {
  key: 1,
  class: "d-flex flex-row align-items-center margin-top"
}
const _hoisted_40 = { key: 2 }
const _hoisted_41 = {
  key: 3,
  id: "step-log-load-failed"
}
const _hoisted_42 = { key: 4 }
const _hoisted_43 = {
  key: 2,
  class: "width-100 d-flex flex-column p-3"
}
const _hoisted_44 = {
  key: 1,
  id: "step-output-load-failed"
}
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { class: "height-100" }
const _hoisted_47 = { class: "nav flex-column nav-tabs no-border height-100" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_50 = { class: "loader-div-sm" }
const _hoisted_51 = ["src", "alt"]
const _hoisted_52 = {
  key: 2,
  class: "drawer-footer"
}
const _hoisted_53 = { class: "d-flex justify-content-end" }

import {
  computed,
  onMounted,
  ref,
  watch,
  nextTick,
} from "vue";
import {
  addOutput as commonAddOutput,
  addMetaoutput as commonAddMetaoutput,
  addUserVariable as commonAddUserVariable,
  addSystemVariable as commonAddSystemVariable,
  addFunction as commonAddFunction,
} from "@/core/json-forms/components/spanInjection";
import {
  ElOption,
  ElScrollbar,
  ElSelect,
  ElTag,
  ElTooltip,
  ElButton,
} from "element-plus";
import { showAlert } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { TYPE } from "vue-toastification";
import { statusColor } from "@/flow/services/flow.service";
import JsonTreeView from "@/flow/components/json-tree-view/JsonTreeView.vue";
import {
  getTooltipForMetaoutput,
  getTooltipForUdv,
} from "@/flow/application/useTooltipForTags";
import { getOutputListForAllStep } from "@/flow/utils/getOutputListForAllStep";
import { getMetaoutputListForAllStep } from "@/flow/utils/getMetaoutputListForAllStep";
import { useAddPositionToStep } from "@/flow/application/useAddPositionToStep";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";
import { concatProcessLogs } from "@/activity/utils/stepLogDetail";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExecutionDetails',
  props: {
    detailType: {},
    step: {},
    flow: {},
    stepDetail: {},
    systemVariables: {},
    expressions: {},
    userDefinedVariables: {},
    steps: {},
    flowStepLogs: {},
    flowLogsState: {}
  },
  emits: [
  "close",
  "get-selected-step-log",
  "request-step-detail",
  "request-flow-logs",
],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const selectedOutputId = ref();

const selectedMetaoutputId = ref();

const emit = __emit;
const props = __props;

const flowActiveTab = ref(1);
const stepActiveTab = ref(1);
const rules = ref(["AND", "OR", "NOT"]);
const operators = ref([
  {
    key: "EQUAL_TO",
    label: "Condition.EqualTo",
  },
  {
    key: "NOT_EQUAL_TO",
    label: "Condition.NotEqualTo",
  },
  {
    key: "CONTAINS",
    label: "Condition.Contains",
  },
  {
    key: "DOES_NOT_CONTAIN",
    label: "Condition.DoesNotContain",
  },
  {
    key: "STARTS_WITH",
    label: "Condition.StartsWith",
  },
  {
    key: "DOES_NOT_START_WITH",
    label: "Condition.DoesNotStartWith",
  },
  {
    key: "IS_GREATER_THAN",
    label: "Condition.IsGreaterThan",
  },
  {
    key: "IS_LESS_THAN",
    label: "Condition.IsLessThan",
  },
  {
    key: "IS_ODD",
    label: "Condition.IsOdd",
  },
  {
    key: "IS_EVEN",
    label: "Condition.IsEven",
  },
  {
    key: "IS_NULL",
    label: "Condition.IsNull",
  },
  {
    key: "IS_NOT_NULL",
    label: "Condition.IsNotNull",
  },
  {
    key: "IS_EMPTY",
    label: "Condition.IsEmpty",
  },
  {
    key: "IS_NOT_EMPTY",
    label: "Condition.IsNotEmpty",
  },
  {
    key: "STEP_FAILED",
    label: "Condition.DidStepFail",
  },
  {
    key: "STEP_SUCCEEDED",
    label: "Condition.DidStepSucceed",
  },
  {
    key: "STEP_FAILED_WITH_CODE",
    label: "Condition.DidStepFailWithCode",
  },
]);
const flowTabs = ref([
  {
    tab: 1,
    name: "Details",
    icon: "info",
    tooltip: t("Common.Details"),
  },
  {
    tab: 2,
    name: "Logs",
    icon: "align-justify",
    tooltip: t("Flow.ProcessLogs"),
  },
]);

const stepTabs = ref([
  {
    tab: 1,
    name: "Details",
    icon: "info",
    tooltip: t("Common.Details"),
  },
  {
    tab: 2,
    name: "Logs",
    icon: "align-justify",
    tooltip: t("Flow.ProcessLogs"),
  },
  {
    tab: 3,
    name: "Output",
    icon: "database",
    tooltip: t("Flow.OutputData"),
  },
]);

const selectedSplitIx = ref();

const uiSplitIx = ref<number | null>(null);

watch(
  () => props.step?.splitIx,
  (backendSplitIx) => {
    uiSplitIx.value =
      backendSplitIx !== undefined && backendSplitIx !== null
        ? backendSplitIx + 1 // show + 1 in UI
        : null;
  },
  { immediate: true }
);

function onUiSplitChange(selectedUiValue: number) {
  if (!props.step) return;

  const backendSplitIx = selectedUiValue - 1;
  emit("get-selected-step-log", backendSplitIx);
}

const uiIterationCount = computed(() => {
  const splitSize = props.step?.splitSize;
  return splitSize !== undefined && splitSize !== null ? splitSize : 0;
});

const flowLogs = computed(() =>
  concatProcessLogs(props.flowStepLogs).split("\n")
);

function setFlowActive(tab) {
  flowActiveTab.value = tab;
}

function convertDate(dateStr) {
  const milliseconds = Date.parse(dateStr);
  const date = new Date(milliseconds);
  return date.toLocaleString();
}

function setStepActive(tab) {
  stepActiveTab.value = tab;
}

const detailLoading = computed(() =>
  props.detailType === "FLOW"
    ? flowActiveTab.value === 2 && props.flowLogsState === "loading"
    : [2, 3].includes(stepActiveTab.value) &&
      props.step?.detailState === "loading"
);

// The page decides whether opening the tab needs a read; the drawer only says it was opened.
watch(
  () => [
    props.detailType,
    flowActiveTab.value,
    stepActiveTab.value,
    props.step?.stepId,
  ],
  () => {
    if (props.detailType === "FLOW") {
      if (flowActiveTab.value === 2) emit("request-flow-logs");
    } else if ([2, 3].includes(stepActiveTab.value)) {
      emit("request-step-detail", stepActiveTab.value === 3 ? "output" : "log");
    }
  },
  { immediate: true }
);
function copyJson() {
  try {
    const jsonString = props.step.output;
    navigator.clipboard
      .writeText(jsonString)
      .then(() => {
        showAlert(TYPE.SUCCESS, t("Flow.CopyJsonSuccess"));
      })
      .catch((err) => {
        showAlert(TYPE.WARNING, t("Flow.CopyJsonError"));
        console.error("Copy error:", err);
      });
  } catch (err) {
    showAlert(TYPE.WARNING, t("Flow.CopyJsonError"));
    console.error("Data formatting error:", err);
  }
}

watch(
  () => props.step,
  () => {
    if (props.step) {
      if (props.step.splitIx) {
        selectedSplitIx.value = props.step.splitIx;
      } else {
        selectedSplitIx.value = null;
      }
    }
  }
);

const outputList = ref([]);
const metaoutputList = ref([]);

watch(
  () => props.steps,
  () => {
    outputList.value = getOutputListForAllStep(
      useAddPositionToStep(props.steps)
    );
    metaoutputList.value = getMetaoutputListForAllStep(
      useAddPositionToStep(props.steps)
    );
  },
  { deep: true, immediate: true }
);

const filteredOutputList = computed(() => {
  const all = outputList.value;
  const avail = props?.stepDetail?.availableOutput;
  const id = props?.stepDetail?.uniqueId;
  return all.filter(
    (item) =>
      avail.some((x) => x.uniqueId === item.uniqueId) || id === item?.uniqueId
  );
});
const filteredMetaoutputList = computed(() => {
  const all = metaoutputList.value;
  const avail = props?.stepDetail?.availableMetaoutput;
  const id = props?.stepDetail?.uniqueId;
  return all.filter(
    (item) =>
      avail.some((x) => x.uniqueId === item.uniqueId) || id === item.uniqueId
  );
});
function injectContent(jsonString: string, divId: string) {
  try {
    const container = document.getElementById(divId);
    if (!container) return;

    const elements = safeParseArray(jsonString);
    elements.forEach((item: any) => handleItem(item, container));
  } catch (err) {
    console.error("Injection error:", err);
    clearContainer(divId);
  }
}

/* ---------------- helpers ---------------- */

function safeParseArray(input: string): any[] {
  try {
    const parsed = JSON.parse(input);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function clearContainer(divId: string) {
  const el = document.getElementById(divId);
  if (el) el.innerHTML = "";
}

function handleItem(item: any, container: HTMLElement) {
  const type = item?.type as string | undefined;
  switch (type) {
    case "input":
      appendInput(container, item?.name);
      break;
    case "output":
      appendOutput(container, item?.name);
      break;
    case "metaoutput":
      appendMetaoutput(container, item?.name);
      break;
    case "user-defined-variable":
      appendUserVariable(container, item?.name);
      break;
    case "system-variable":
      appendSystemVariable(container, item?.name);
      break;
    default:
      appendFunction(container, item);
  }
}

function appendInput(container: HTMLElement, name: string) {
  if (name === "\n") {
    container.appendChild(document.createElement("br"));
  } else {
    container.appendChild(document.createTextNode(name));
  }
}

function appendOutput(container: HTMLElement, name: string) {
  const arr = name?.split("/#") ?? [];
  const stepStr = arr[0]?.replace("/", "");
  selectedOutputId.value = stepStr ? Number.parseInt(stepStr, 10) : "";
  const path = arr.length >= 2 ? `/#${arr[1]}` : "";

  const span = commonAddOutput(
    {
      name: `/${selectedOutputId.value}/#${arr[1]}`,
      path,
      stepIndex: selectedOutputId.value,
      tooltip: "",
    },
    filteredOutputList.value || [],
    0,
    false
  );
  container.appendChild(span);
}

function appendMetaoutput(container: HTMLElement, name: string) {
  const parts = name?.split("/#") ?? [];
  const right = parts.length >= 2 ? parts[1] : "";
  const arr = right ? right.split("@#") : [];
  const metaIdx = arr.length >= 2 ? arr[0]?.split("-") : [];
  selectedMetaoutputId.value =
    metaIdx.length >= 2 ? Number.parseInt(metaIdx[1], 10) : "";
  const path = right ? `/#${arr[1]}` : "";

  const span = commonAddMetaoutput(
    {
      name: `/${selectedMetaoutputId.value}/#${arr[1]}`,
      path,
      stepIndex: selectedMetaoutputId.value,
      tooltip: "",
    },
    filteredMetaoutputList.value || [],
    0,
    false
  );
  container.appendChild(span);
}

function appendUserVariable(container: HTMLElement, name: string) {
  const arr = name?.split("/#") ?? [];
  const path = arr.length >= 2 ? `/#${arr[1]}` : "";

  const span = commonAddUserVariable(
    {
      name: path,
      path,
      stepIndex: 0,
      tooltip: "",
    },
    props.userDefinedVariables || [],
    0,
    false
  );
  container.appendChild(span);
}

function appendSystemVariable(container: HTMLElement, name: string) {
  const span = commonAddSystemVariable(
    { name, tooltip: props.systemVariables?.[name] || "" },
    { name, tooltip: "" },
    0
  );
  container.appendChild(span);
}

function appendFunction(container: HTMLElement, item: any) {
  const matched = props.expressions.find((e: any) => e.name === item?.name);
  const spans = commonAddFunction(
    { ...item, tooltip: matched?.description },
    0
  );
  spans.forEach((el: HTMLSpanElement) => container.appendChild(el));
}

/* -------- mount + reinject (cleaned) -------- */

onMounted(() => {
  if (props.step?.splitIx) selectedSplitIx.value = props.step.splitIx;

  const filters = props.stepDetail?.filter ?? [];
  filters.forEach((cond: any, idx: number) => {
    injectContent(cond?.firstInput, `first-input-${idx}-div`);
    injectContent(cond?.secondInput, `second-input-${idx}-div`);
  });
});

function reInject() {
  const filters = props.stepDetail?.filter ?? [];
  filters.forEach((cond: any, idx: number) => {
    const firstId = `first-input-${idx}-div`;
    const secondId = `second-input-${idx}-div`;

    clearContainer(firstId);
    injectContent(cond?.firstInput, firstId);

    clearContainer(secondId);
    injectContent(cond?.secondInput, secondId);
  });
}

watch(
  () => props?.stepDetail,
  async () => {
    await nextTick();
    reInject();
  },
  { immediate: true }
);

watch(stepActiveTab, async (newTab) => {
  if (newTab === 1) {
    await nextTick();
    reInject();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.detailType === 'FLOW')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.flow?.flowName), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.step?.name), 1)),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        id: "flow-close-step",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "times" })
      ])
    ]),
    (_ctx.detailType === 'FLOW')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (flowActiveTab.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("strong", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("Common.Status")) + " :  ", 1),
                    _createVNode(_unref(ElTag), {
                      type: _unref(statusColor)(_ctx.flow?.status)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.flow?.status), 1)
                      ]),
                      _: 1
                    }, 8, ["type"])
                  ])
                ]),
                (_ctx.flow.startedOn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.ExecutionTime")), 1),
                      _createTextVNode(" : " + _toDisplayString(convertDate(_ctx.flow?.startedOn)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.flow.finishedOn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.EndTime")), 1),
                      _createTextVNode(" : " + _toDisplayString(convertDate(_ctx.flow?.finishedOn)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (flowActiveTab.value === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_ctx.flowLogsState === 'error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)("Common.DetailLoadFailed")), 1))
                  : (flowLogs.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowLogs.value, (log) => {
                          return (_openBlock(), _createElementBlock("p", {
                            class: "font-size-12 text-sm-start color-dark-gray",
                            key: log
                          }, _toDisplayString(log), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)("Common.NoProcessLog")), 1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("ul", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowTabs.value, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': flowActiveTab.value === item.tab }]),
                  onClick: ($event: any) => (setFlowActive(item.tab)),
                  key: item.tab
                }, [
                  _createVNode(_unref(ElTooltip), {
                    effect: "custom",
                    content: item.tooltip,
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_17, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: item.icon,
                          class: "fa-fw",
                          size: "lg"
                        }, null, 8, ["icon"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["content"])
                ], 10, _hoisted_16))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (stepActiveTab.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_ctx.step?.splitIx)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.SplitIx")), 1),
                      _createTextVNode(" : " + _toDisplayString(_ctx.step.splitIx), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("strong", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("Common.Status")) + " :  ", 1),
                    _createVNode(_unref(ElTag), {
                      type: _unref(statusColor)(_ctx.step?.status)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.step.status), 1)
                      ]),
                      _: 1
                    }, 8, ["type"])
                  ])
                ]),
                (_ctx.step?.startedOn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.ExecutionTime")), 1),
                      _createTextVNode(" : " + _toDisplayString(convertDate(_ctx.step?.startedOn)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.step?.finishedOn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.EndTime")), 1),
                      _createTextVNode(" : " + _toDisplayString(convertDate(_ctx.step?.finishedOn)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.stepDetail?.filter?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Filters")) + " : ", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepDetail?.filter, (condition, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "d-flex flex-row align-items-center",
                    key: condition
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createVNode(_unref(ElSelect), {
                        modelValue: condition.rule,
                        "onUpdate:modelValue": ($event: any) => ((condition.rule) = $event),
                        size: "small",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rules.value, (rule) => {
                            return (_openBlock(), _createBlock(_unref(ElOption), {
                              key: rule,
                              value: rule,
                              label: rule
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]), [
                        [_vShow, index !== 0]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn", 
                condition.leftParen ? 'btn-oneTeg-inline' : 'btn-oneTeg-outline'
              ]),
                        style: {"height":"32px","padding":"0 8px !important"},
                        onClick: ($event: any) => (condition.leftParen = !condition.leftParen),
                        disabled: ""
                      }, " ( ", 10, _hoisted_27)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", {
                          id: `first-input-${index}-div`,
                          class: "form-control root-div read-only-input"
                        }, null, 8, _hoisted_30)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_unref(ElSelect), {
                        modelValue: condition.condition,
                        "onUpdate:modelValue": ($event: any) => ((condition.condition) = $event),
                        size: "small",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (operator) => {
                            return (_openBlock(), _createBlock(_unref(ElOption), {
                              key: operator.key,
                              value: operator.key,
                              label: _unref(t)(operator.label),
                              disabled: ""
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", {
                          id: `second-input-${index}-div`,
                          class: "form-control root-div read-only-input"
                        }, null, 8, _hoisted_34)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn", 
                condition.rightParen
                  ? 'btn-oneTeg-inline'
                  : 'btn-oneTeg-outline'
              ]),
                        style: {"height":"32px","padding":"0 8px !important"},
                        onClick: ($event: any) => (condition.rightParen = !condition.rightParen),
                        disabled: ""
                      }, " ) ", 10, _hoisted_36)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (stepActiveTab.value === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                (_ctx.step?.splitSize && _ctx.step?.splitSize > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.IterationCount")), 1),
                      _createTextVNode(" : " + _toDisplayString(_ctx.step?.splitSize), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.step?.splitSize && _ctx.step?.splitSize > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.SelectIteration")), 1),
                      _createTextVNode(" :  "),
                      _createVNode(_unref(ElSelect), {
                        modelValue: uiSplitIx.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((uiSplitIx).value = $event)),
                        size: "small",
                        disabled: _ctx.step?.detailState === 'loading',
                        onChange: onUiSplitChange,
                        placeholder: _unref(t)('Common.SelectIteration')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uiIterationCount.value, (item) => {
                            return (_openBlock(), _createBlock(_unref(ElOption), {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled", "placeholder"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.step.processLog)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.step.processLog.split('\n'), (log, index) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: "font-size-12 text-sm-start color-dark-gray",
                          key: index
                        }, _toDisplayString(log), 1))
                      }), 128))
                    ]))
                  : (_ctx.step.detailState === 'error')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_unref(t)("Common.DetailLoadFailed")), 1))
                    : (_ctx.step.detailState !== 'loading')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_unref(t)("Common.NoProcessLog")), 1))
                      : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (stepActiveTab.value === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                (_ctx.step.output)
                  ? (_openBlock(), _createBlock(_unref(ElScrollbar), {
                      key: 0,
                      class: "margin-top-10",
                      height: '90%',
                      ref: "scrollbar"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(JsonTreeView, {
                          path: '',
                          tab: 1,
                          data: _ctx.step.output,
                          searchable: true,
                          "search-data": _ctx.step.output
                        }, null, 8, ["data", "search-data"])
                      ]),
                      _: 1
                    }, 512))
                  : (_ctx.step.detailState === 'error')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_unref(t)("Common.DetailLoadFailed")), 1))
                    : (_ctx.step.detailState !== 'loading')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(t)("Common.NoOutput")), 1))
                      : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("ul", _hoisted_47, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepTabs.value, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': stepActiveTab.value === item.tab }]),
                  onClick: ($event: any) => (setStepActive(item.tab)),
                  key: item.tab
                }, [
                  _createVNode(_unref(ElTooltip), {
                    effect: "custom",
                    content: item.tooltip,
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_49, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: item.icon,
                          class: "fa-fw",
                          size: "lg"
                        }, null, 8, ["icon"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["content"])
                ], 10, _hoisted_48))
              }), 128))
            ])
          ])
        ])),
    _withDirectives(_createElementVNode("div", _hoisted_50, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: _unref(t)('Common.Loading'),
        class: "loader-logo-40"
      }, null, 8, _hoisted_51)
    ], 512), [
      [_vShow, detailLoading.value]
    ]),
    (stepActiveTab.value === 3 && _ctx.step.output)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_unref(ElButton), {
              id: "copy-json-button",
              type: "primary",
              onClick: copyJson,
              class: "btn-oneTeg2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("Flow.CopyJson")), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})